import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { GetCountryList, CountryState } from '@app/core/Store';
import { GetAllContactsBasedonId, GetExaminersBasedonId, SaveCompanyContacts, SaveIndependentExaminers } from '@app/core/Store/report/report-settings/report-settings.action';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-contact-detail-popup',
  templateUrl: './contact-detail-popup.component.html',
  styleUrls: ['./contact-detail-popup.component.scss']
})
export class ContactDetailPopupComponent implements OnInit {
  @Input() selectedId: any;
  @Input() isContact: any;
  @Input() selectedContactType: any;
  @Input() tabName: any;
  @Input() commenceDate: any;
  contactDetailForm: FormGroup;
  savePayload: any = {};
  renderer: Renderer2;
  countryList: any[];
  accountingBodies: any[] = ["ACCA","ICAEW","ICAS","CIMA","AAT","AIA","IFA"];
  constructor(public datepipe: DatePipe,private commonService: CommonService, public dialog: MatDialog, private store: Store,
  public dialogRef: MatDialogRef<ContactDetailPopupComponent>,   private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.setForm();
    this.GetCountryListData();
    if(this.selectedId) this.getDetailsbyId();

    this.contactDetailForm.get('dateAppointed')?.valueChanges.subscribe((appointedDate) => {
      const ceasedDate = this.contactDetailForm.get('dateCeased')?.value;
      if (ceasedDate && new Date(ceasedDate) < new Date(appointedDate)) {
        this.contactDetailForm.get('dateCeased')?.reset();
      }
    });

    this.contactDetailForm.get('dateCeased')?.valueChanges.subscribe((ceasedDate) => {
      const appointedControl = this.contactDetailForm.get('dateAppointed');

      if (!ceasedDate) {
        appointedControl?.clearValidators();
        appointedControl?.updateValueAndValidity({ emitEvent: false });
        return;
      }

      const ceased = new Date(ceasedDate);

      // Ignore invalid typing values
      if (isNaN(ceased.getTime())) return;

      appointedControl?.setValidators([Validators.required]);
      appointedControl?.updateValueAndValidity({ emitEvent: false });
    });
  }

  setForm(): void{
    this.contactDetailForm = new FormGroup({
      name: new FormControl('', [Validators.required, this.commonService.whiteSpaceValidate]),
      lastName: new FormControl('', this.selectedContactType !== 3 ? [Validators.required, this.commonService.whiteSpaceValidate] : []),
      ceased: new FormControl(false),
      country: new FormControl(''),
      county: new FormControl(''),
      address1: new FormControl(''),
      address2: new FormControl(''),
      city: new FormControl(''),
      postCode: new FormControl(''),
      dateReported: new FormControl(''),
      dateAppointed: new FormControl(''),
      dateCeased: new FormControl(''),
      accountingBody : new FormControl(''),
      firmName:new FormControl(''),
    });
  }

  getDetailsbyId(): void{
    let actionName;
      if(this.isContact && this.selectedId) actionName = GetAllContactsBasedonId
      else actionName = GetExaminersBasedonId;
      this.store.dispatch(new actionName(this.selectedId)).pipe().subscribe(
      (response: any) => {
        const res = this.isContact ? response.reportSettings?.contactDetails : response.reportSettings?.examinerDetails;
        
        this.contactDetailForm.patchValue({
          name: res.name,
          lastName: res.lastName,
          country: res.country,
          county: this.isContact ? res?.country : res?.county,
          address1: res.address1,
          address2: res.address2,
          city: res.city,
          postCode: res.postCode,
          dateAppointed: res.dateAppointed,
          dateCeased: res.dateCeased,
          accountingBody : res?.accountingbody,
          firmName:res?.firmName,
          ceased: res?.isCeased
        })
      }
    );
  }

  GetCountryListData(): void {
    this.store.dispatch(new GetCountryList())
      .pipe(
        tap(() => {
          this.countryList = this.store.selectSnapshot(CountryState.getCountry);
          if (!this.selectedId && this.countryList.length > 0) {
            this.contactDetailForm.controls.country.setValue(this.countryList[205].id);
          }
        })
      )
      .subscribe();
  }

  onSave(): any{
    this.spinner.show();
    let dateAppointed=(this.contactDetailForm.controls['dateAppointed'].value)?this.datepipe
          .transform(
            this.contactDetailForm.controls['dateAppointed'].value,
            'yyyy-MM-dd'
          )
          ?.toString():null;
    let dateCeased=(this.contactDetailForm.controls['dateCeased'].value)?this.datepipe
          .transform(
            this.contactDetailForm.controls['dateCeased'].value,
            'yyyy-MM-dd'
          )
          ?.toString():null;
    try{
      if(this.isContact) {
        this.savePayload = {
          "id": this.selectedId || '00000000-0000-0000-0000-000000000000',
          "companyId": '00000000-0000-0000-0000-000000000000',
          "type": this.selectedContactType,
          "name": this.contactDetailForm.controls['name'].value,
          "lastName": this.contactDetailForm.controls['lastName'].value,
          "address1": this.contactDetailForm.controls['address1'].value,
          "address2": this.contactDetailForm.controls['address2'].value,
          "city": this.contactDetailForm.controls['city'].value,
          "postCode": this.contactDetailForm.controls['postCode'].value,
          "country": this.contactDetailForm.controls['county'].value,
          "dateAppointed": dateAppointed,
          "dateCeased": dateCeased,
          "accountingbody": this.contactDetailForm.controls['accountingBody'].value || null,
          "isActive": true,
          "isDelete": true,
          "createdBy": '00000000-0000-0000-0000-000000000000',
          "updatedBy": '00000000-0000-0000-0000-000000000000',
          "updatedOn": null,
          "firmName":this.contactDetailForm.controls['firmName'].value || null,
          "isCeased": this.contactDetailForm.controls['ceased'].value,
        }
      } else {
        this.savePayload = {
          "id": this.selectedId || '00000000-0000-0000-0000-000000000000',
          "companyId": '00000000-0000-0000-0000-000000000000',
          "name": this.contactDetailForm.controls['name'].value,
          "lastName": this.contactDetailForm.controls['lastName'].value,
          "address1": this.contactDetailForm.controls['address1'].value,
          "address2": this.contactDetailForm.controls['address2'].value,
          "city": this.contactDetailForm.controls['city'].value,
          "postCode": this.contactDetailForm.controls['postCode'].value,
          "country": this.contactDetailForm.controls['country'].value,
          "county": this.contactDetailForm.controls['county'].value,
          "accountingbody": this.contactDetailForm.controls['accountingBody'].value,
          "isShowonreport": false,
          "isActive": true,
          "isDelete": true,
          "createdBy": '00000000-0000-0000-0000-000000000000',
          "updatedBy": '00000000-0000-0000-0000-000000000000',
          "updatedOn": null,
          "firmName":this.contactDetailForm.controls['firmName'].value || null,
        }
      }
    } catch (error) {
        this.spinner.hide();
        this.commonService.onFailure(NotificationTextMessage.errorMessage);
        return false;
    }
    return true;
  }

  saveContactDetails(): void{
    if (this.contactDetailForm.invalid) {
      this.commonService.addValidation(this.contactDetailForm, this.renderer);
    } else if(this.onSave()){
      let actionName;
      if(this.isContact) actionName = SaveCompanyContacts;
      else actionName = SaveIndependentExaminers;
      this.store.dispatch(new actionName(this.savePayload)).pipe().subscribe(
        (response: any) => {
           this.commonService.onSucess(
                NotificationTextMessage.successMessage
              );
          this.dialogRef.close(this.contactDetailForm);
        },
        (error: any) => {
          console.error('Failed:', error);
        }
      );
    }
  }

  dateCeasedFilter = (date: Date | null): boolean => {
    const appointedDate = this.contactDetailForm?.get('dateAppointed')?.value;
    if (!date || !appointedDate) {
      return true; 
    }
    return date >= new Date(appointedDate);
  };
}
